module.exports = __webpack_public_path__ + "images/3-i2f249913ac312423e0d18083bc4399d6.svg";